












































































































































































































import Vue from "vue";
import RouterMove from "@/mixins/routerMixin";
import { GET_IMAGE_URL } from "@/plugins/constants";
import { mapMutations } from "vuex";
import { capitalize } from '@/plugins/constants'
import {
  FilterMutations,
  TFilterState,
} from "@/store/modules/filter/definitions.filter";

//eslint-disable-next-line
const t = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;

export default Vue.extend({
  mixins: [RouterMove],
  name: "footerComponet",
  data: () => ({
    icons: [
      `${GET_IMAGE_URL(false)}/icons/instagram.svg`,
      `${GET_IMAGE_URL(false)}/icons/facebook.svg`
    ],
    img: `${GET_IMAGE_URL(false)}/assets/3u_white_incomplete.png`,
    images: [
      `${GET_IMAGE_URL(false)}/assets/banner_1.webp`,
      `${GET_IMAGE_URL(false)}/assets/banner_2.webp`,
      `${GET_IMAGE_URL(false)}/assets/banner_3.webp`,
    ],
    imgAfip: `${GET_IMAGE_URL(false)}/assets/afip.webp`,
    dialog: false,
    nameNewsletter: "",
    emailNewsletter: "",
    varRefreshFooter: true,
  }),
  methods: {
    ...mapMutations('filter', [FilterMutations.SET_FILTER_STATE]),    
    refreshFooter() {
      this.varRefreshFooter = false;
      setTimeout(() => {
        this.varRefreshFooter = true;
      }, 50);
    },
    validateInputsNewsletter() {
      return this.nameNewsletter.length != 0 && t.test(this.emailNewsletter);
    },
    pushProducts(params: string) {
      const final_collection = capitalize(params.toLowerCase())
      this[FilterMutations.SET_FILTER_STATE]({
        currentPage: 1,
        selectedOrderBy: "Novedad",
        selectedCollection: final_collection
      } as TFilterState);
      this.$router.push('/shop/collection');
    },
  },
});
